<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
     <div v-if="temPermissao('segmento-ensino-medio')" class="main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <b-row>
            <b-col cols="12" class="mt-1 mb-1" v-for="(material, index) in lists" :key="index">
              <router-link :to="{
                name: 'render-conteudo-exclusivo',
                params: { paramsForUrl: material.LinkFree || '', nomeApostila: material.title || '' },
                query: { material: formatParam(material.description) },
              }">
                <b-card no-body class="p-3 card_sistemacpv border-light">
                  <div class="d-flex align-items-center">
                    <i class="fa-light fa-book fa-xl mr-2"></i>
                    <span>{{ material.title }}</span>
                  </div>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'ENSINO MÉDIO',
      pageSubtitle: 'Resoluções - Matemática - Caderno 10',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree:
            'ensino-medio/resolucoes/matematica/caderno-10/matcol10-r-_-numeros-complexos-1.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
          bundle: 'E_medio',
          title: 'Matemática Numeros Complexo',
          segment: '',
          discipline: 'Matemática',
          description: 'matcol10-R',
          toolTip: '',
          isbn: 'Resoluções - Caderno ',
          numeral: '10',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'ensino-medio/resolucoes/matematica/caderno-10/matcol11-r-_-polinomios.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
          bundle: 'E_medio',
          title: 'Matemática Polinômios',
          segment: '',
          discipline: 'Matemática',
          description: 'matcol11-R',
          toolTip: '',
          isbn: 'Resoluções - Caderno ',
          numeral: '10',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'ensino-medio/resolucoes/matematica/caderno-10/matcol12-r-_-equacoes-algebricas-ou-polinomiais.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
          bundle: 'E_medio',
          title: 'Equações Algébricas ou Polinomiais',
          segment: '',
          discipline: 'Matemática',
          description: 'matcol12-R',
          toolTip: '',
          isbn: 'Resoluções - Caderno ',
          numeral: '10',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'ensino-medio/resolucoes/matematica/caderno-10/matcol20-r-_-trigonometria.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
          bundle: 'E_medio',
          title: 'Trigonometria',
          segment: '',
          discipline: 'Matemática',
          description: 'matcol20-R',
          toolTip: '',
          isbn: 'Resoluções - Caderno ',
          numeral: '10',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>